import React from 'react';
import {RootState} from "../../../../../../reducers";
import {getAvailabilities, getItemGroups, getItems, getPromotions} from "../../../../../services/Menu/reducer";
import {connect} from "react-redux";
import ProductPromotions from "./ProductPromotions";
import MenuProductImages from "../MenuProductImages";
import {getSession} from "../../../../../services/Session/reducer";
import ProductDescription from "./ProductDescription";
import ProductVariants from "./ProductVariants/ProductVariants";
import ProductNonConfigurableItems from "./ProductNonConfigurableItems/ProductNonConfigurableItems";
import ItemViewHelper from "../../../../../services/Menu/services/Item/ItemViewHelper";
import {getCart} from "../../../../../services/Cart/reducer";
import ItemHelper from "../../../../../services/Menu/services/Item/ItemHelper";
import ProductModifierGroups from "./ProductModifierGroups/ProductModifierGroups";
import ProductModifierGroupOptionsIncluded
    from "./ProductModifierGroups/OptionsIncluded/ProductModifierGroupOptionsIncluded";
import ProductComment from "./ProductComment";

interface OwnProps {
    productState: Record<string, any>;
    displayImages?: true;
    product: Record<string, any>;
    productItemGroup: Record<string, any> | undefined;
    updateProductState: (productState: Record<string, any>) => void;
    productView: Record<string, any>;
    nested?: true;
    isProductAvailable: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductContent = ({
                            promotions,
                            productState,
                            displayImages,
                            product,
                            items,
                            availabilities,
                            session,
                            productItemGroup,
                            updateProductState,
                            cart,
                            productView,
                            nested,
                            isProductAvailable
                        }: Props) => {
    const productConfigurableModifierGroups = [...productView.configurable_modifier_groups].sort((a: any, b: any) => a.position - b.position || a.name.localeCompare(b.name));
    const productNonConfigurableModifierGroups = [...productView.non_configurable_modifier_groups].sort((a: any, b: any) => a.position - b.position || a.name.localeCompare(b.name));

    const getProductVariants = () => {
        if (!productItemGroup) return [];

        const validItems: {
            item: Record<string, any>;
            itemInfo: Record<string, any>;
            itemView: Record<string, any>;
        }[] = [];
        productItemGroup.items.forEach((item: any) => {
            const itemInfo = ItemHelper.getItem(items, item.item_id);
            const itemView = ItemViewHelper.parseItem(itemInfo, availabilities, [], session.pickup_at, undefined, cart, session.order_type);

            if (itemView && !itemView.selected_order_type_disabled) {
                validItems.push({
                    item,
                    itemView,
                    itemInfo
                });
            }
        });

        return validItems.sort((a, b) => a.item.position - b.item.position || (a.itemInfo.name && b.itemInfo.name && a.itemInfo.name.localeCompare(b.itemInfo.name)));
    };

    const isProductASet = productView.modifier_groups.some((modifierGroup: Record<string, any>) => {
        return modifierGroup.options.some((option: Record<string, any>) => option.modifier_groups.length > 0 && option.is_customize);
    });

    return (
        <div className="product-content">
            {displayImages && <MenuProductImages product={product} isProductAvailable={isProductAvailable}/>}
            <ProductPromotions promotions={promotions} productState={productState}/>
            <ProductDescription productView={productView}/>
            <ProductNonConfigurableItems variants={getProductVariants()} productItemGroup={productItemGroup}
                                         productModifierGroups={productNonConfigurableModifierGroups}
                                         isProductASet={isProductASet}/>
            <ProductModifierGroupOptionsIncluded includedModifierGroups={productView.included_modifier_groups}
                                                 productState={productState} updateProductState={updateProductState}
                                                 isProductAvailable={isProductAvailable} isProductASet={isProductASet}
            />
            <ProductVariants variants={getProductVariants()} productItemGroup={productItemGroup}
                             updateProductState={updateProductState} productState={productState}
                             isProductAvailable={isProductAvailable}/>
            <ProductModifierGroups
                productModifierGroups={productConfigurableModifierGroups}
                updateProductState={updateProductState}
                productState={productState}
                productView={productView}
                isProductAvailable={isProductAvailable}
                isProductASet={isProductASet}
            />
            <ProductComment updateProductState={updateProductState} isProductAvailable={isProductAvailable}
                            productState={productState} nested={nested}/>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    promotions: getPromotions(state.menu),
    items: getItems(state.menu),
    itemGroups: getItemGroups(state.menu),
    availabilities: getAvailabilities(state.menu),
    session: getSession(state.session),
    cart: getCart(state.cart)
})

const connector = connect(mapStateToProps);
export default connector(ProductContent);